import useTranslation from 'next-translate/useTranslation'
import React from 'react'
import MultipleCostInvoiceRow from 'tennders-finance/cost-invoice/components/multiple-cost-invoice/MultipleCostInvoiceRow'
import GHref from 'tennders-market/common/components/element/GHref'
import MultipleSalesInvoiceRow
  from 'tennders-finance/sales-invoice/components/multiple-sales-invoice/MultipleSalesInvoiceRow'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const MultipleSalesInvoiceLines = (props) => {
  const {
    lines,
    errors,
    removeLine,
    form,
    onFormChange,
    addNewLine,
    selectedTransaction,
    editMode,
    isCreditNote,
    defaultVat,
    selectedPaymentTerm
  } = props
  const { t } = useTranslation()
  return (
    <>
      <p className="text-uppercase mb-20 ls-1">
        <strong>Orders : </strong>
      </p>
      {lines.map((line, i) => (
        <MultipleSalesInvoiceRow
          initialErrors={errors[i]}
          editMode={editMode}
          errors={errors}
          selectedPaymentTerm={selectedPaymentTerm}
          selectedTransaction={selectedTransaction}
          index={i}
          key={line.id}
          initialCustomerRefs={line.customerReferenceList || []}
          totalLines={lines.length === 0 || !lines[0].orderName ? 0 : lines.length}
          keyIndex={line.id}
          saved={line?.saved}
          isCreditNote={isCreditNote}
          defaultVat={defaultVat}
          reversedVat={form?.reversedVat}
          removeLine={removeLine}
          onFormChange={onFormChange}
          companyId={form.company || form?.toCompany?.id}
        />
      ))}

      {!isCreditNote && (
        <GHref className="btn-border medium standard-btn mt-16" onClick={() => addNewLine()}>
          <span className=" mr-6">
            <FontAwesomeIcon icon={faPlus} />
          </span>
          {t('multiple_cost_invoice:add_order')}
        </GHref>
      )}

    </>
  )
}

export default React.memo(MultipleSalesInvoiceLines)
